<template>
	<div>
		<span class="payment-condition-wrapper d-flex align-items-center">
			<div
				class="payment-condition-tag d-flex justify-content-evenly align-items-center"
				:class="props.classes"
				:style="{ height: `${props.height}px`, width: `${props.width}px` }">
				<slot name="icon"></slot>
				<slot name="content"></slot>
			</div>
		</span>
	</div>
</template>

<script setup lang="ts">
import { defineProps, withDefaults } from "vue"

// Props
interface Props {
	classes: string[]
	height?: number
	width?: number
}

const props = withDefaults(defineProps<Props>(), {
	classes: () => [" bg-primary-blue", "text-white"],
	height: 20,
	width: 55,
})
</script>

<style scoped>
.payment-condition-wrapper {
	font-weight: bold;
	font-size: 14px;
	font-style: normal;
}

.payment-condition-tag {
	border-radius: 3px;
	padding-top: 2px;
}

.orange-border {
	border: 1px solid var(--orange-900);
}
</style>
